export default class Faq {
    constructor(names, items) {
        this.names = names;
        this.items = items;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.names)) { if(!value) { result = false; break; }; }

        if(result) result = this.items && this.items.length;

        return result;
    }
}